import React, { useState, useEffect } from 'react';
import Toast from 'shared/common/toast';
import ArticlesHttp from './articles.service';
import { toast } from 'react-toastify';
import './article.css';
import { Offcanvas } from 'react-bootstrap';
import ArticleHttp from 'pages/article-page/article.service';
import logoImage from 'assets/images/xyz.jpeg';

interface PropsType {
  handleModal: any;
  isShow: boolean;
}

// const ArticleView: React.FC<PropsType> = ({ handleModal, isShow }) => {
//   const [articles, setArticles] = useState<any>([]);
//   const [labels, setLabels] = useState<any>(['all']);
//   const [articleView, setArticleView] = useState<boolean>(false);
//   const [selectedArticle, setSelectedArticle] = useState<any>({});
//   const [selectedElement, setSelectedElement] = useState<any>('0');

//   useEffect((): any => {
//     // getArticles();
//   }, [isShow]);

//   const stringToHTML = (str) => {
//     var parser = new DOMParser();
//     var doc = parser.parseFromString(str, 'text/html');
//     return doc.body;
//   };

//   // useEffect((): any => {
//   //   articles.map((doc) => {
//   //     if (0 !== doc.label_names.length) {
//   //       doc.label_names?.map((code: any, i: number) => {
//   //         if (!labels.includes(code)) {
//   //           labels.push(code);
//   //         }
//   //       });
//   //     }
//   //   });
//   // }, [articles]);

//   useEffect((): any => {
//     let buttons = document.getElementById(selectedElement);
//     if (buttons != null) {
//       buttons.classList.add('active');
//     }
//   }, [articleView]);

//   const getArticles = async () => {
//     try {
//       const res: any = await ArticlesHttp.getArticles();
//       if (res.articles) {
//         setArticles(res.articles);
//         selectedItem();
//       }
//     } catch (e: any) {
//       // toast.error(e);
//       // console.error(e);
//     }
//   };

//   const filterArticles = async (data: any, id: any) => {
//     let buttons = document.getElementById(id);
//     if (buttons != null) {
//       document.getElementById(selectedElement).classList.remove('active');
//       setSelectedElement(id);
//       buttons.classList.add('active');
//     }

//     try {
//       const res: any = await ArticlesHttp.filterArticles(data);
//       if (res.articles) {
//         setArticles(res.articles);
//       }
//     } catch (e: any) {
//       //toast.error(e);
//       console.log(e);
//     }
//   };

//   const selectedItem = () => {
//     labels.map((data, index) => {
//       if (data === 'all') {
//         setSelectedElement(index.toString());
//         let buttons = document.getElementById(index.toString());
//         if (buttons != null) {
//           buttons.classList.add('active');
//         }
//       }
//     });
//   };

//   useEffect(() => {
//     const fetchArticles = async () => {
//       try {
//         const data = await ArticleHttp.getArticle();
//         setArticles(data.data); // assuming `data` has the articles array directly or an array within `data`
//       } catch (err) {
//         console.log(err);
//       }
//     };

//     fetchArticles();
//     console.log('articles', articles[0].id);
//   }, []);
//   return (
//     <>
//       {/*<Toast/>*/}
//       <Offcanvas
//         show={isShow}
//         onHide={() => handleModal(false)}
//         placement='end'
//       >
//         <Offcanvas.Header closeButton className='bg-light'>
//           <Offcanvas.Title>
//             <h5 className='px-4 font-weight-bold'>
//               {!articleView ? 'Articles' : 'Article view'}
//             </h5>
//           </Offcanvas.Title>
//         </Offcanvas.Header>
//         {/* <div className='modal-header'>
//           <a
//             onClick={(event) => {
//               event.preventDefault();

//               setArticleView(false);
//             }}
//             href=''
//             className='flex font-medium text-gray-600 hover:text-gray-500'
//           >
//             <svg
//               className='m-0.5'
//               xmlns='http://www.w3.org/2000/svg'
//               height='20px'
//               viewBox='0 0 24 24'
//               width='20px'
//               fill='#000000'
//             >
//               <path d='M0 0h24v24H0z' fill='none' />
//               <path d='M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z' />
//             </svg>
//           </a>
//           <h4 className='modal-title'>
//             {!articleView ? 'Articles' : 'Article view'}
//           </h4>
//           <span
//             aria-hidden='true'
//             className='Close'
//             onClick={() => {
//               setArticleView(false);
//               setSelectedElement('0');
//               setLabels(['all']);
//               handleModal(false);
//             }}
//           >
//             &times;
//           </span>
//         </div> */}
//         <Offcanvas.Body>
//           <div
//             className='px-3'
//             style={{
//               overflowY: 'scroll',
//               height: '80vh',
//               position: 'relative',
//             }}
//           >
//             {!articleView ? (
//               <>
//                 {labels.length > 0 ? (
//                   <div className='mt-2 row'>
//                     <ul className='no-bullets mb-0'>
//                       {labels.map((label: any, index: number) => {
//                         return (
//                           <li
//                             key={index}
//                             className='button-categories float-start'
//                           >
//                             <a
//                               id={index.toString()}
//                               key={index}
//                               style={{
//                                 color: '#99834d',
//                                 borderColor: '#99834d',
//                                 borderRadius: '50px',
//                                 fontSize: '12px',
//                               }}
//                               href='#'
//                               className='button-categories-link btn btn-light btn-lg mb-3 mx-1 text-decoration-none'
//                               onClick={() => {
//                                 // filterArticles(label, index.toString());
//                               }}
//                             >
//                               {label}
//                             </a>
//                           </li>
//                         );
//                       })}
//                     </ul>
//                   </div>
//                 ) : (
//                   ''
//                 )}
//                 {articles?.length>0 ? (
//                   articles?.map((label: any, index: number) => {
//                     return (
//                       <div
//                         className='mx-0 row justify-content-between'
//                         key={index}
//                       >
//                         <a
//                           href='#'
//                           style={{
//                             background: '#dedece',
//                             color: '#99834d',
//                             fontSize: '13px',
//                           }}
//                           className='fw-bold text-decoration-none m-2 p-2 rounded'
//                           onClick={() => {
//                             setArticleView(true);
//                             setSelectedArticle(label);
//                           }}
//                         >
//                           {/* <div className='d-flex'> */}
//                             <img
//                               // src={
//                               //   label.attributes.thumbnail.data.attributes.url
//                               // }
//                               src={logoImage}
//                               height={100}
//                             />
//                             <span className='inline-block align-middle ...'>
//                               {' '}
//                               {label.attributes.title}
//                             </span>
//                           {/* </div> */}

//                           <span className='float-end'>
//                             <button
//                               className='btn btn-light btn-sm rounded-circle'
//                               style={{ padding: '0.05rem 0.25rem' }}
//                             >
//                               <svg
//                                 xmlns='http://www.w3.org/2000/svg'
//                                 height='20px'
//                                 viewBox='0 0 24 24'
//                                 width='20px'
//                                 fill='#99834d'
//                               >
//                                 <path d='M0 0h24v24H0z' fill='none' />
//                                 <path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' />
//                               </svg>
//                             </button>
//                           </span>
//                         </a>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div className='mt-2 text-center'>No article to preview</div>
//                 )}
//               </>
//             ) : (
//               <div
//                 id='previewDiv'
//                 style={{ width: '100%' }}
//                 dangerouslySetInnerHTML={{ __html: selectedArticle.body }}
//               />
//             )}
//           </div>
//         </Offcanvas.Body>
//       </Offcanvas>
//     </>
//   );
// };

const ArticleView: React.FC<PropsType> = ({ handleModal, isShow }) => {
  const [articles, setArticles] = useState<any>([]);
  const [labels, setLabels] = useState<any>(['all']);
  const [articleView, setArticleView] = useState<boolean>(false);
  const [selectedArticle, setSelectedArticle] = useState<any>({});
  const [selectedElement, setSelectedElement] = useState<any>('0');

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = await ArticleHttp.getArticle();
        setArticles(data.data); // assuming `data` has the articles array directly or an array within `data`
      } catch (err) {
        console.log(err);
      }
    };

    fetchArticles();
    // console.log('articles', articles[0]?.id);
  }, []);
  return (
    <>
      {/*<Toast/>*/}
      <Offcanvas
        show={isShow}
        onHide={() => handleModal(false)}
        placement='end'
      >
        <Offcanvas.Header closeButton className='bg-light'>
          <div className='modal-header'>
            <a
              onClick={(event) => {
                event.preventDefault();

                setArticleView(false);
              }}
              href=''
              className='flex font-medium text-gray-600 hover:text-gray-500'
            >
              <svg
                className='m-0.5'
                xmlns='http://www.w3.org/2000/svg'
                height='20px'
                viewBox='0 0 24 24'
                width='20px'
                fill='#000000'
              >
                <path d='M0 0h24v24H0z' fill='none' />
                <path d='M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z' />
              </svg>
            </a>
          </div>
          <Offcanvas.Title>
            <h5 className='px-4 font-weight-bold'>
              {!articleView ? 'Articles' : 'Article view'}
            </h5>
          </Offcanvas.Title>
        </Offcanvas.Header>
        {/* <div className='modal-header'>
          <a
            onClick={(event) => {
              event.preventDefault();

              setArticleView(false);
            }}
            href=''
            className='flex font-medium text-gray-600 hover:text-gray-500'
          >
            <svg
              className='m-0.5'
              xmlns='http://www.w3.org/2000/svg'
              height='20px'
              viewBox='0 0 24 24'
              width='20px'
              fill='#000000'
            >
              <path d='M0 0h24v24H0z' fill='none' />
              <path d='M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z' />
            </svg>
          </a>
          <h4 className='modal-title'>
            {!articleView ? 'Articles' : 'Article view'}
          </h4>
          <span
            aria-hidden='true'
            className='Close'
            onClick={() => {
              setArticleView(false);
              setSelectedElement('0');
              setLabels(['all']);
              handleModal(false);
            }}
          >
            &times;
          </span>
        </div> */}
        <Offcanvas.Body>
          <div
            className='px-3'
            style={{
              overflowY: 'scroll',
              height: '80vh',
              position: 'relative',
            }}
          >
            {!articleView ? (
              <>
                {articles?.length > 0 ? (
                  articles?.map((label: any, index: number) => {
                    return (
                      <div
                        className='mx-0 row justify-content-between'
                        key={index}
                      >
                        <a
                          href='#'
                          style={{
                            background: '#dedece',
                            color: '#99834d',
                            fontSize: '13px',
                          }}
                          className='fw-bold text-decoration-none m-2 p-2 rounded'
                          onClick={() => {
                            setArticleView(true);
                            setSelectedArticle(label);
                          }}
                        >
                          <div className='container'>
                            <div className='row'>
                              <div className='col-auto'>
                                <img
                                  src={
                                    label?.attributes?.thumbnail?.data
                                      ?.attributes?.url
                                  }
                                  alt={label?.attributes?.title}
                                  height={100}
                                />
                              </div>
                              <div className='col'>
                                <span className='align-middle d-inline-block'>
                                  {label?.attributes?.title}
                                </span>
                              </div>
                            </div>
                          </div>

                          <span className='float-end'>
                            <button
                              className='btn btn-light btn-sm rounded-circle'
                              style={{ padding: '0.05rem 0.25rem' }}
                            >
                              <svg
                                xmlns='http://www.w3.org/2000/svg'
                                height='20px'
                                viewBox='0 0 24 24'
                                width='20px'
                                fill='#99834d'
                              >
                                <path d='M0 0h24v24H0z' fill='none' />
                                <path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' />
                              </svg>
                            </button>
                          </span>
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className='mt-2 text-center'>No article to preview</div>
                )}
              </>
            ) : (
              <div>
                <h5 className='mb-3'>{selectedArticle?.attributes?.title}</h5>

                {selectedArticle?.attributes?.thumbnail?.data?.attributes
                  ?.url && (
                  <img
                    src={
                      selectedArticle?.attributes?.thumbnail?.data?.attributes
                        ?.url
                    }
                    alt={selectedArticle?.attributes?.title}
                    style={{
                      width: '100%',
                      marginBottom: '20px',
                      height: '50%',
                    }}
                  />
                )}

                <div
                  id='previewDiv'
                  style={{ width: '100%' }}
                  dangerouslySetInnerHTML={{
                    __html: selectedArticle.attributes.content,
                  }}
                />
              </div>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ArticleView;
